import React from "react";

const PaymentPlans: React.FC = () => {
  return null;
};

export default PaymentPlans;
